import { REPORTS, WELL } from "../configurations/Urls";
import Session from "../helpers/SessionHelper";
import axios from "axios";

const WellReportService = {
  async getWellAndIrrigs() {
    const response = await axios.get(`${REPORTS}/wells-irrigs`);
    return response;
  },

  async submitWellTestForm(payload) {
    if (!payload) return;
    const headers = Session.getHeaderWithStaffToken();
    const response = await axios.post(REPORTS, payload, {
      headers: headers,
    });
    return response;
  },

  async getWellReports(payload) {
    if (!payload) return;
    const headers = Session.getHeaderWithStaffToken();
    const response = await axios.get(payload, {
      headers: headers,
    });
    return response;
  },

  async exportReports(payload) {
    if (!payload) return;
    const headers = Session.getHeaderWithStaffToken();
    headers.Accept = "application/vnd.ms-excel";
    const response = await axios.get(payload, {
      headers: headers,
      responseType: "blob",
      redirect: "follow",
    });
    return response;
  },

  async updateWellConnectionDetails(payload) {
    if (!payload) return;
    const headers = Session.getHeaderWithStaffToken();
    const response = await axios.put(`${WELL}/connection`, payload, {
      headers: headers,
    });
    return response;
  },

  async getFieldWellCropReports(payload) {
    if (!payload) return;
    const headers = Session.getHeaderWithStaffToken();
    const response = await axios.get(payload, {
      headers: headers,
    });
    return response;
  },
};
export default WellReportService;
